<template>
  <Head title="FAQ" />
  <PagesLayout>
      <div class="component-background-desktop">
        <Heading title="Perguntas Frequentes" class="px-4 xl:px-[15.5vw] xl:pt-6 sm:pt-6"/>
            <div class="px-2.5 pb-[35px] min-h-[70vh] pt-5 xl:mx-[280px]">
                <button @click="goBack" class="back-sm hover:text-blue-600 hover:underline text-sm text-[#2E59FF] pb-6">Voltar</button>
                <Topic v-for="(topic,key) in faq.data" :key="key" :title="topic.name" :accordions="topic.questions" class="w-[600px]" />
            </div>
      </div>
  </PagesLayout>
</template>

<script>
import { Head } from "@inertiajs/inertia-vue3";
import Heading from "@/Components/UI/Texts/Heading.vue";
import PagesLayout from "@/Layouts/Pages.vue";
import Topic from "@/Components/Topic.vue";
import Accordion from "@/Components/UI/Modals/Accordion.vue";

export default {
  components: {
    Heading,
    Head,
    Accordion,
    Topic,
    PagesLayout,
  },
  props: {
    faq: Object,
  },
  methods: {
    goBack(){
      return window.history.go(-1);
    }
  }
};
</script>
